<script setup>
  const { src } = defineProps(['src']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <div>
    <VideoLoop>
      <source :src="src" type="video/mp4" />
    </VideoLoop>
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  div {
    position: absolute;

    width: 100%;
    height: 100%;

    top: 0;
    left: 0;

    @include dark-layer;
  }

  video {
    position: relative;

    width: 100%;
    height: 100%;

    object-fit: cover;
  }
</style>
